import PropTypes from 'prop-types';
import partial from 'transmute/partial';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import AssociatedObjectsCardPaginator from './AssociatedObjectsCardPaginator';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { AnyCrmObjectTypePropType } from 'customer-data-objects-ui-components/propTypes/CrmObjectTypes';
import I18n from 'I18n';
import { COMPANY_TYPE_ID, normalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
import { useAssociatedObjectsCardContentContext } from '../context/AssociatedObjectsCardContext';
import AssociatedObjectsCardSort from './AssociatedObjectsCardSort';
import Association from './association/Association';
import { DISPLAY_LABEL_FALLBACK } from '../constants/displayLabelFallback';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getAssociationPrimaryDisplayLabel = ({
  toObjectTypeId,
  primaryAssociation
}) => {
  if (toObjectTypeId === COMPANY_TYPE_ID) {
    if (!primaryAssociation || !primaryAssociation.properties) {
      return undefined;
    }
    const name = primaryAssociation.properties.find(property => property.name === 'name');
    return name && name.value || undefined;
  }
  return DISPLAY_LABEL_FALLBACK;
};
export default function AssociatedObjectsCardContent({
  cardId,
  objectId,
  objectType,
  onPreview,
  onViewMore,
  sortConfiguration,
  toObjectTypeId
}) {
  var _associationsData$imp, _associationsData$imp2, _associationsData$imp3, _associationsData$imp4, _associationsData$imp5;
  const {
    associationsData,
    associationTypesData
  } = useAssociatedObjectsCardContentContext();
  const singularTranslatedObjectType = associationTypesData.associationTypes[0] && associationTypesData.associationTypes[0].toObjectTypeDefinition && associationTypesData.associationTypes[0].toObjectTypeDefinition.singularForm || I18n.text(`cardAssociatedObjects.genericSingularObject`);
  const associatedObjectsIds = (_associationsData$imp = (_associationsData$imp2 = associationsData.impliedUnlabeledAssociationObjects) === null || _associationsData$imp2 === void 0 ? void 0 : _associationsData$imp2.results.map(association => association.id)) !== null && _associationsData$imp !== void 0 ? _associationsData$imp : [];
  const primaryAssociation = associationsData.primaryAssociationObject && associationsData.primaryAssociationObject.results[0];
  const primaryAssociationObjectId = primaryAssociation && primaryAssociation.id || undefined;
  const filteredImpliedUnlabeledAssociations = (_associationsData$imp3 = (_associationsData$imp4 = associationsData.impliedUnlabeledAssociationObjects) === null || _associationsData$imp4 === void 0 ? void 0 : _associationsData$imp4.results.filter(result => result.id !== primaryAssociationObjectId)) !== null && _associationsData$imp3 !== void 0 ? _associationsData$imp3 : [];
  const totalAssociationsCount = I18n.formatNumber(((_associationsData$imp5 = associationsData.impliedUnlabeledAssociationObjects) === null || _associationsData$imp5 === void 0 ? void 0 : _associationsData$imp5.total) || 0);
  const primaryAssociationPrimaryDisplayLabel = getAssociationPrimaryDisplayLabel({
    primaryAssociation,
    toObjectTypeId
  });
  const renderAssociation = ({
    object,
    isPrimary,
    index
  }) => {
    const associatedObjectId = object.id;
    const currentNum = I18n.formatNumber(index + 1);
    const ariaLabel = `${singularTranslatedObjectType} ${currentNum}/${totalAssociationsCount}`;
    return /*#__PURE__*/_jsx(Association, {
      associatedObjectsIds: associatedObjectsIds,
      fromObjectTypeId: normalizeTypeId(objectType),
      fromObjectId: objectId,
      cardId: cardId,
      object: object,
      isPrimary: isPrimary,
      objectTypeId: toObjectTypeId,
      ariaLabel: ariaLabel,
      onPreview: partial(onPreview, {
        objectTypeId: toObjectTypeId,
        objectId: String(associatedObjectId)
      }),
      primaryAssociationObjectInfo: {
        primaryAssociationObjectId,
        primaryAssociationPrimaryDisplayLabel
      }
    }, associatedObjectId);
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [sortConfiguration && !!sortConfiguration.length && /*#__PURE__*/_jsx(AssociatedObjectsCardSort, {
      sortConfiguration: sortConfiguration
    }), primaryAssociation && renderAssociation({
      object: primaryAssociation,
      isPrimary: true,
      index: 0
    }), filteredImpliedUnlabeledAssociations && filteredImpliedUnlabeledAssociations.map((association, index) => renderAssociation({
      object: association,
      isPrimary: false,
      index: primaryAssociation ? index + 1 : index
    })), /*#__PURE__*/_jsx(AssociatedObjectsCardPaginator, {
      onViewMore: onViewMore
    })]
  });
}
AssociatedObjectsCardContent.propTypes = {
  onViewMore: PropTypes.func.isRequired,
  onPreview: PropTypes.func.isRequired,
  onEmailClick: PropTypes.func,
  objectId: PropTypes.number.isRequired,
  objectType: AnyCrmObjectTypePropType.isRequired,
  toObjectTypeId: ObjectTypeIdType.isRequired
};